/** @jsx jsx */
import React, { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Text, Box, jsx } from "theme-ui"

import { Context } from "../../context/MainContext"

import enums from "../../util/enums"

function CaseBuilderHeader({ colors }) {
  const styles = {
    color: colors.heading,
    container: {
      display: "flex",
    },
  }

  const data = useStaticQuery(graphql`
    query CaseHeader {
      sanityCaseBuilder(_id: { eq: "caseBuilder" }) {
        headlineLeft_bundle
        headlineLeft_view
        headlineRight_bundle
        headlineRight_view
      }
    }
  `)

  const {
    store: { caseBuilderMode },
  } = useContext(Context)

  const {
    headlineLeft_bundle,
    headlineLeft_view,
    headlineRight_bundle,
    headlineRight_view,
  } = data.sanityCaseBuilder

  return (
    <React.Fragment>
      <Box sx={{ gridColumn: "1 / 7", gridRow: 1 }}>
        <Text as="p" sx={styles}>
          {(caseBuilderMode === enums.mode.view && headlineLeft_view) || ""}
          {(caseBuilderMode === enums.mode.bundle && headlineLeft_bundle) || ""}
        </Text>
      </Box>
      <Box
        sx={{
          gridColumn: "7 / -1",
          gridRow: 1,
          "@media screen and (max-width: 950px)": {
            marginLeft: "-50px",
          },
        }}
      >
        <Text sx={styles}>
          {caseBuilderMode === enums.mode.view && (
            <Text as="p">{headlineRight_view || ""}</Text>
          )}
          {caseBuilderMode === enums.mode.bundle && (
            <Box sx={styles.container}>{headlineRight_bundle || ""}</Box>
          )}
        </Text>
      </Box>
    </React.Fragment>
  )
}

export default CaseBuilderHeader
